<template>
  <certificate-list :certLevel="2" />
</template>

<script>
import CertificateList from '../vendors/vendor-certificate/certificate.vue'
export default {
  name: 'ProductCertificate',
  components: { CertificateList }
}
</script>
